module.exports = __webpack_public_path__ + "img/project1.ef182691.png";